export const CATEGORY_SEPARATOR = '|';
export const CATEGORY_QUERYPARAM = 'categories';

// Tracking
export const TRACKING_PAGENAME = 'smartwatches';
